import { APP_DISCLAIMER } from '@/constants';
import { cn } from '@/utils';
import React from 'react';

/** Props for the Disclaimer component */
interface DisclaimerProps {
  /** The disclaimer text content to display */
  text?: string;
  /** Optional className for custom styling */
  className?: string;
}

/**
 * Disclaimer component to display important information or warnings to users.
 */
export const Disclaimer: React.FC<DisclaimerProps> = ({
  text = APP_DISCLAIMER,
  className,
  ...props
}) => {
  const classNames = cn(
    'flex items-center justify-center gap-2.5',
    'p-2.5',
    'typography-disclaimer',
    'w-full',
    className,
  );

  return (
    <div className={classNames} role="contentinfo" {...props}>
      <p className="mx-auto max-w-3xl whitespace-pre-wrap leading-4">{text}</p>
    </div>
  );
};

Disclaimer.displayName = 'Disclaimer';

export default Disclaimer;
